import { styled } from "@l2r-front/l2r-ui"

export const MenuWrapper = styled("div")(({ theme }) => ({
    alignItems: "flex-start",
    display: "flex",
    height: "fit-content",
    justifyContent: "flex-end",
    position: "fixed",
    left: theme.spacing(6),
    top: theme.spacing(8),
    zIndex: 3,
}))